import React, { useState, useEffect, useCallback } from 'react'
import parse from 'html-react-parser';
import Tag from 'antd/lib/tag';

const Popup = ({ opened, onClose, item, updateFilter }) =>
{
  const [overlayTop,setOverlayTop] = useState(0);
  const [opening,setOpening] = useState(false);

  useEffect(() => {
    if(opened)
    {
      if(typeof window !== 'undefined')
        setOverlayTop(window.pageYOffset + 100);
      setTimeout(() => {
        setOpening(true)
      },50);
    }
  },[opened,item]);

  const closePopup = useCallback((e) => {
    e.preventDefault();
    setOpening(false);
    onClose(e);
  },[opened,item,onClose]);

  return(
    <div className={"overlay" + (opening ? ' opening' : '')} onClick={closePopup} onKeyDown={closePopup} role={'dialog'}>
      <div className="popup container popupContainer" style={{top: overlayTop}}>
        <div className={"popupItem" + (item.replayThumbnail === "" ? " noImage" : "")} onClick={(e)=>{e.stopPropagation();}}  onKeyDown={(e)=>{e.stopPropagation();}} role={'dialog'}>
          <a href="/replay" className="closeBtn" onClick={closePopup}>Close</a>
          <div className="content clearfix">
            <div className="upperContent clearfix">
              <div className="text">
                <div className="upperTag">
                  <Tag className="type" color="#38241c"
                    onClick={(e) => {
                      e.stopPropagation();
                      closePopup(e);
                      updateFilter('format-label',item.replaySessionFormat);
                    }}
                  >{item.replaySessionFormat}</Tag>
                  <Tag className="system" color="#7f6960"
                    onClick={(e) => {
                      e.stopPropagation();
                      closePopup(e);
                      updateFilter('system-label',item.replaySystemName);
                    }}
                  >{item.replaySystemName}</Tag>
                </div>
                <div className="title">
                  {item.replayScenarioName}
                </div>
                <div className="date">
                  {'投稿時間：'+item.replayTimestamp}
                </div>
                <div className="nameData">
                  <div className="gmName">
                    <div className="label">GM:</div>
                    <div className="name"><a  href="/replay" onClick={(e) => {
                      e.preventDefault();
                      closePopup(e);
                      updateFilter('gm-label',item.replayGm);
                  }}>{item.replayGm}</a></div>
                  </div>
                  {item.replayPlayersName !== "" &&
                    <div className="playerName">
                      <div className="label">參與玩家: </div>
                      <div className="name">{item.replayPlayersName}</div>
                    </div>
                  }
                  {item.replayScenarioAuthor !== null &&
                    <div className="scenarioAuthor">
                      <div className="label">劇本作者: </div>
                      <div className="name">{item.replayScenarioAuthor}</div>
                    </div>
                  }
                  {item.replayScenarioSource !== null &&
                    <div className="scenarioSource">
                      <div className="label">劇本出處: </div>
                      <div className="name">{item.replayScenarioSource.search('http') === 0 ?
                        <a href={item.replayScenarioSource}  target="_blank" rel="noreferrer">{item.replayScenarioSource}</a> : 
                        item.replayScenarioSource
                      }</div>
                    </div>
                  }
                </div>
                {(item.replayHashTag !== "" && item.replayHashTag.length > 0) &&
                  <div className="tagList">
                    {item.replayHashTag.map((tag,index) =>(
                      <a href="/replay" onClick={(e) => {
                        e.preventDefault();
                        closePopup(e);
                        updateFilter('tag',[tag]);
                      }} key={"hashPopup_" + index}>{'#' + tag}</a>
                    ))}
                  </div>
                }
                </div>
              {item.replayThumbnail &&
                <div className="frame">
                  <img src={item.replayThumbnail} alt={'團務印象圖片'} />
                </div>
              }
            </div>
            <div className="bottomContent"> 
              <div className="desc blockContent">
                {parse(item.replayScenarioDescription.replace(/(\r\n|\n|\r)/gm, '<br />'))}
              </div>
              <div className="houseRules blockContent">
                <span className="label">是否使用了房規：</span>
                  {parse(item.replayHouserules.replace(/(\r\n|\n|\r)/gm, '<br />'))}
              </div>
              {item.replayFootnote !== "" && item.replayFootnote !== null &&
                <div className="gmWords blockContent">
                  <span className="label">GM的一言：</span>
                  {parse(item.replayFootnote.replace(/(\r\n|\n|\r)/gm, '<br />'))}
                </div>
              }
              
              <div className="logLink">
                <a href={item.replayLink} target="_blank" rel="noreferrer">觀看該團團錄</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Popup;